import _ from "lodash";
import React from "react";
import classes from "./FieldComponent.scss";
import ThemeSelectComponent from "../ThemeSelectComponent";
import SubjectGroupSelect from "../SubjectGroupSelect";
import SubjectGroupSelectV2 from "../SubjectGroupSelectV2";
import ResponsesComponent from "../ResponsesComponent";
import KeyConcepts from "../KeyConcepts";
import MultiSelectWithModal from "../MultiSelectWithModal";
import AssessStudentLearning from "../AssessStudentLearning";
import AssessmentLibrary from "Assessments/components/AssessmentLibrary";
import IBSkills from "../IBSkills";
import NestedSelectComponent from "../NestedSelectComponent";
import Duration from "../Duration";
import AssessmentTool from "../AssessmentTool";
import BenchmarkCheckList from "../BenchmarkCheckList";
import NestedChecklist from "../NestedChecklist";
import IBReflection from "../IBReflection";
import LeLibrary from "LearningEngagement/components/LeLibrary";
import IBResources from "../IBResources";
import RelatedConcepts from "../RelatedConcepts";
import RelatedConceptsV2 from "../RelatedConceptsV2";
import MultiSelectQuestions from "../MultiSelectQuestions";
import OrganizationResourcesSelection from "../OrganizationResourcesSelection";
import CustomSelectDropDown from "../CustomSelectDropdown";
import MeasureAssessingWrapper from "../MeasureAssessingWrapper";
import ToggleSwitchInput from "../ToggleSwitchInput";
import ListModal from "../ListModal";
import TOKObject from "../TOKObject";
import SubjectGroupWithSubjectView from "../SubjectGroupWithSubjectView";
import SubjectGroupWithSubjectViewOnly from "../SubjectGroupWithSubjectViewOnly";
import SubjectViewOnly from "../SubjectViewOnly";
import SwitcherComponent from "../SwitcherComponent";
import CriteriaRubricAssessmentWithComments from "../CriteriaRubricAssessmentWithComments";
import SubmissionItem from "../SubmissionItem";
import SubmissionTable from "../SubmissionTable";
import MultiWindowTable from "../MultiWindowTable";
import DynamicTable from "../DynamicTable";
import InputNumberListWithTag from "../InputNumberListWithTag";
import CheckListWithPopup from "../CheckListWithPopup";
import CheckListWithDuration from "../CheckListWithDuration";
import ActionTableV2 from "../ActionTableV2";
import ActionTableV3 from "../ActionTableV3";
import FieldAIEvaluation from "../FieldAIEvaluation";
import FeedbackTable from "../FeedbackTable";
import FieldAIEvaluationLanguage from "../FieldAIEvaluationLanguage";

import RichTextEditor from "UIComponents/RichTextEditor";
import ImageDropzoneV2 from "UIComponents/ImageDropzoneV2";
import UISegmentedControl from "UIComponents/UISegmentedControl";
import UIInputNumberField from "UIComponents/UIInputNumberField";
import RadioButtonList from "UIComponents/RadioButtonList";
import { FormSelectDropdown } from "UIComponents/SelectDropdown";
import CheckListContainer from "UIComponents/CheckListContainer";
import Listview from "UIComponents/Listview";
import Textview from "UIComponents/Textview";
import BenchmarkView from "UIComponents/BenchmarkView";
import TimeSelector from "UIComponents/TimeSelector";
import AudioRecorderSelector from "UIComponents/AudioRecorderSelector";
import DateSelector from "UIComponents/DateSelector";
import DateDurationSelector from "UIComponents/DateDurationSelector";
import DateDurationSelectorV2 from "UIComponents/DateDurationSelectorV2";
import DurationFieldInput from "UIComponents/DurationFieldInput";
import TextFieldInput from "UIComponents/TextFieldInput";
import FormDateDurationSelector from "UIComponents/FormDateDurationSelector";
import { DragAndDropList } from "UIComponents/UIInputList";
import UIInputCheckList from "UIComponents/UIInputCheckList";
import GroupedKeyConceptsView from "UIComponents/GroupedKeyConceptsView";
import { FormTextInput } from "UIComponents/InputTextField";
import { FormTextAreaInput } from "UIComponents/TextAreaInput";
import NotAddedEmptyView from "UIComponents/NotAddedEmptyView";
import InputNumberFieldV2 from "UIComponents/InputNumberFieldV2";
import I18nHOC from "UIComponents/I18nHOC";
import FieldDropdown from "UIComponents/FieldDropdown";
import ControlledInputWrapper from "UIComponents/ControlledInputWrapper";
import GenericCardList from "UIComponents/GenericCardList";
import GenericCheckList from "UIComponents/GenericCheckList";
import StepperInputField from "UIComponents/StepperInputField";
import MultiSelectComponent from "UIComponents/MultiSelectComponent";
import MultiSelectComponentV2 from "UIComponents/MultiSelectComponentV2";
import ActionTable from "AppComponents/ActionTable";
import CollaboratorV2 from "AppComponents/CollaboratorV2";
import MultiSelectWithImage from "UIComponents/MultiSelectWithImage";
import { AttachmentList } from "Attachment";
import BenchmarksComponent from "../BenchmarksComponent";
import { colors } from "Constants";
import MultiField from "../MultiField";
import MultiFieldV2 from "../MultiFieldV2";
import AIAnalysisScale from "../AIAnalysisScale";
import DynamicChildren from "../DynamicChildren";
import { compose } from "lib/apolloClient";
import SelectAttachmentComponent from "../SelectAttachmentComponent";
import LineSeparator from "../LineSeparator";
import AssessmentCategory from "../AssessmentCategory";
import DurationAndPrescribedPractical from "../DurationAndPrescribedPractical";
import MaxScore from "../MaxScore";
import TaskWeightV2 from "../TaskWeightV2";
import EmptyComponent from "../EmptyComponent";
import FinalRemark from "../FinalRemark";
import LearningGoalsRating from "../LearningGoalsRating";
import AlertWithCheckbox from "../AlertWithCheckbox";
import AddLearningGoals from "../AddLearningGoals";
import LearningGoalsListView from "../LearningGoalsListView";
import LearningGoalsNestedView from "../LearningGoalsNestedView";
import TreeView from "../TreeView";
import CardView from "../CardView";
import {
  FieldRichText,
  FieldMultiLineInput,
  FieldReflection,
  FieldInput,
  FieldInputList,
  FieldCardsV2,
  FieldChecklist,
  FieldNestedChecklist,
} from "Fields";
import { getFieldEmptyText } from "Fields/FieldUtils";
import LearningIntentions from "../LearningIntentions";
import AssessmentCoverUpload from "../AssessmentCoverUpload";
import ImageCoverUpload from "../ImageCoverUpload";
import DurationAndTopic from "../DurationAndTopic/DurationAndTopic";
import withFieldComponentHOC from "./WithFieldComponentHOC";
import StudentResponse from "../StudentResponse";
import classNames from "classnames";
import WorksheetCreateType from "../WorksheetCreateType";
import TaskWeightV3 from "../TaskWeightV3";
import PlannerElementDataSet from "../PlannerElementDataSet";

const MODAL_FIELD_TIMEOUT = 15;
const TEXT_FIELD_TIMEOUT = 4;

/* we have added new spacing between field label and field or between fields.
Here you can find related documentation about spacing in different types of fields.
https://coda.io/d/Project-Enhancements-Solution-Design_dg0F6s8KvM3/Project-Step-and-Field-Spacing_suufy
*/
const styles = {
  submissionItemLabelStyle: {
    marginBottom: "16px",
  },
  submissionItemLabelStyleV2: {
    marginBottom: "8px",
  },
  attachmentListLabelStyle: {
    marginBottom: "16px",
  },
  switcherComponentLabelStyle: {
    marginBottom: "8px",
  },
};

const segmentedControlStyle = {
  containerStyle: {
    //width: "max-content"
  },
};

const defaultViewStyle = {
  labelStyle: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: colors.textDefault,
  },
  labelContainerStyle: {
    marginBottom: 0,
  },
};

const audioRecorderSelectorStyles = {
  innerContainerStyle: { padding: "0 60px" },
};

const defaultEditStyle = {};

const SelectDropdownDynamicOptions = props => {
  const {
    updateInputField,
    fieldKey,
    fieldTypeConfig,
    value,
    parentEntityMode,
  } = props;

  const shouldStoreArrayValue = _.get(
    fieldTypeConfig,
    "shouldStoreArrayValue",
    false
  );
  const updateDropdownValue = (params, extraParams) => {
    if (shouldStoreArrayValue) {
      params[fieldKey] = _.isEqual(params[fieldKey], "")
        ? []
        : [params[fieldKey]];
    }
    //to get the value of resolve minimal tree we need the subjects in nodes object of extra params(second argument of update input field)
    updateInputField(params, { nodes: extraParams });
  };
  return (
    <FormSelectDropdown
      {...props}
      value={shouldStoreArrayValue ? _.first(value || []) : value}
      label={props.label}
      subText={props.subText}
      areOptionsEmptyAllowed={true}
      options={props.options}
      name={props.fieldKey}
      updateInputField={updateDropdownValue}
      placeholder={props.placeholder}
      parentEntityMode={parentEntityMode}
      {...props.fieldTypeConfig}
    />
  );
};

const TypeComponent = props => {
  const { dsVersion } = props;
  const isDSV2 = dsVersion === "2.0";
  switch (props.type) {
    case "MultiWindowTable": {
      return <MultiWindowTable {...props} />;
    }

    case "CheckListWithPopup": {
      return <CheckListWithPopup {...props} />;
    }

    case "ActionTable": {
      return (
        <ActionTable
          {...props}
          showCheckbox={_.get(props, "fieldTypeConfig.showCheckbox", true)}
          value={props.value ? props.value : { rows: [], columns: [] }}
        />
      );
    }
    case "ActionTableV2": {
      return <ActionTableV2 {...props} />;
    }
    case "ActionTableV3": {
      return <ActionTableV3 {...props} />;
    }
    case "CustomSelectDropdown": {
      return (
        <CustomSelectDropDown
          {...props}
          {...props.field_config}
          {...props.styles}
        />
      );
    }
    case "DurationSelector":
      return (
        <TimeSelector
          {...props}
          storeValueInSeconds={true}
          SelectedTimeformat="H [h] mm [m]"
          label={props.label}
          subText={props.subText}
          value={props.value ? props.value : 0}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          timeComponentStyle={props.timeComponentStyle}
        />
      );

    case "DateSelector":
      return <DateSelector {...props} />;
    case "DateDurationSelector":
      return (
        <DateDurationSelector
          {...props}
          isDisabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          minDate={props.options?.minDate}
          maxDate={props.options?.maxDate}
          value={props.value ?? { startDate: null, endDate: null }}
          updateInputField={(params, extraParams) => {
            props.updateInputField(
              //when dateDuration is used as a Field we return an object
              //with key as dateDuration. eg : {dateDuration : {startDate: moment..}}
              //else when it is mapped with details fields we return {startDate : moment..}

              props.name && props.isMappedWithDetailsFields
                ? params[props.name]
                : params,
              {
                isMappedWithDetailsFields: props.isMappedWithDetailsFields,
              }
            );
          }}
        />
      );
    case "DurationFieldInput":
      return <DurationFieldInput {...props} />;
    case "TextFieldInput":
      return (
        <TextFieldInput
          {...props}
          disabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
        />
      );
    case "DateDurationSelectorV2":
      return (
        <DateDurationSelectorV2
          {...props}
          isDisabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          minDate={props.options?.minDate}
          maxDate={props.options?.maxDate}
          value={props.value ?? { startDate: null, endDate: null }}
          updateInputField={(params, extraParams) => {
            props.updateInputField(
              //when dateDuration is used as a Field we return an object
              //with key as dateDuration. eg : {dateDuration : {startDate: moment..}}
              //else when it is mapped with details fields we return {startDate : moment..}

              props.name && props.isMappedWithDetailsFields
                ? params[props.name]
                : params,
              {
                isMappedWithDetailsFields: props.isMappedWithDetailsFields,
                ...extraParams,
              }
            );
          }}
        />
      );
    case "FormDateDurationSelector":
      return (
        <FormDateDurationSelector
          {...props}
          disabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          minDate={props.options?.minDate}
          maxDate={props.options?.maxDate}
          value={props.value ?? { startDate: null, endDate: null }}
          updateInputField={(params, extraParams) => {
            props.updateInputField(
              //when dateDuration is used as a Field we return an object
              //with key as dateDuration. eg : {dateDuration : {startDate: moment..}}
              //else when it is mapped with details fields we return {startDate : moment..}

              props.name && props.isMappedWithDetailsFields
                ? params[props.name]
                : params,
              {
                isMappedWithDetailsFields: props.isMappedWithDetailsFields,
              }
            );
          }}
          size="medium"
        />
      );
    case "AttachmentList":
      return (
        <AttachmentList
          {...props}
          {...props.options}
          name={props.fieldKey}
          cardType={
            props.showAttachmentItemV3 ? "horizontalV3" : props.cardType
          }
          parentId={props.fieldId}
          value={props.value ? props.value : []}
          horizontalCardStyle={{
            ...(props.studentTemplateCardStyle || {}),
            ...(props.horizontalCardStyle || {}),
          }}
          emptyComponent={
            props.emptyComponent ? props.emptyComponent : <NotAddedEmptyView />
          }
          deleteEntityLabel={props.label}
          labelContainerStyle={{
            ...styles.attachmentListLabelStyle,
            ...props.labelContainerStyle,
          }}
          assessmentId={props.parentId}
          onTurnitinAttachmentRename={props.onTurnitinAttachmentRename}
        />
      );
    case "InputNumberList_Ported": {
      const {
        label,
        subText,
        value,
        fieldKey,
        emptyText,
        onBlurInputField,
        onFocusInputField,
        updateInputField,
        customRef,
        mode,
        labelComponent,
        fieldLockedObject,
        readOnly,
        labelStyle,
        labelContainerStyle,
        contentStyle = {},
        isSinglePageAndNewUnitView,
        enhancedEmptyTextFormat,
        isDependentField,
        emptyEditText,
        shouldInitOptions,
        showListItemNumber,
        options,
        disabled,
        containerStyle,
      } = props;

      return (
        <FieldInputList
          label={label}
          subText={subText}
          value={value ? value : []}
          name={fieldKey}
          emptyText={emptyText}
          onBlurInputField={onBlurInputField}
          onFocusInputField={onFocusInputField}
          updateInputField={updateInputField}
          labelComponent={labelComponent}
          customRef={customRef}
          mode={mode}
          fieldLockedObject={fieldLockedObject}
          readOnly={readOnly}
          isDisabled={props?.lockFieldForSchoolGroups}
          labelStyle={labelStyle}
          labelContainerStyle={labelContainerStyle}
          onFocusOut={props.onFocusOut}
          customTextStyle={contentStyle}
          isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
          isDependentField={isDependentField}
          emptyEditText={emptyEditText}
          shouldInitOptions={shouldInitOptions}
          showListItemNumber={showListItemNumber}
          options={options}
          disabled={disabled}
          containerStyle={containerStyle}
        />
      );
    }
    case "InputNumberList":
      return (
        <DragAndDropList
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value ? props.value : []}
          placeholder={props.placeholder}
          name={props.fieldKey}
          isDisabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          displayDisabledAsActive={
            props?.lockFieldForSchoolGroups ??
            props?.displayDisabledAsActive ??
            false
          }
        />
      );
    case "UIInputCheckList":
      return (
        <UIInputCheckList
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value ? props.value : []}
          placeholder={props.placeholder}
          name={props.fieldKey}
          isDisabled={props.lockFieldForSchoolGroups}
          listType={props.fieldTypeConfig.listType}
        />
      );
    case "IBResourceList":
      return (
        <IBResources
          {...props}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          label={props.label}
          subText={props.subText}
          parentId={props.parentId}
          parentType={props.parentType}
          mode={props.mode}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
        />
      );

    case "IBReflection": {
      const { styles = {} } = props;
      return (
        <IBReflection
          {...props}
          responses={props.responses}
          label={props.label}
          subText={props.subText}
          value={props.value}
          mode={props.mode}
          name={props.fieldKey}
          options={props.options}
          updateInputField={props.updateInputField}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
          subTextStyle={styles.subTextStyle}
          isSinglePageAndNewUnitView={props.isSinglePageAndNewUnitView}
        />
      );
    }
    case "InputField": {
      const { useControlledInput = false } = props;
      return useControlledInput ? (
        <ControlledInputWrapper
          value={props.value}
          updateInputField={props.updateInputField}
          name={props.fieldKey}
        >
          <FormTextInput
            {...props}
            isRequired={props.isRequired}
            error={props?.fieldTypeConfig?.error}
            onBlurInputField={props.onBlurInputField}
            onFocusInputField={props.onFocusInputField}
            label={props.label}
            subText={props.subText}
            value={props.value}
            placeholder={props.placeholder}
            name={props.fieldKey}
            updateInputField={props.updateInputField}
            disabled={props.lockFieldForSchoolGroups || props.disabled}
            size={isDSV2 ? "medium" : "large"}
            testId={props.testId}
            type={props?.fieldTypeConfig?.inputType}
            min={props?.fieldTypeConfig?.min}
            max={props?.fieldTypeConfig?.max}
          />
        </ControlledInputWrapper>
      ) : (
        <FormTextInput
          {...props}
          isRequired={props.isRequired}
          error={props?.fieldTypeConfig?.error}
          onBlurInputField={props.onBlurInputField}
          onFocusInputField={props.onFocusInputField}
          label={props.label}
          subText={props.subText}
          value={props.value}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          disabled={props.lockFieldForSchoolGroups || props.disabled}
          size={isDSV2 ? "medium" : "large"}
          testId={props.testId}
          type={props?.fieldTypeConfig?.inputType}
          min={props?.fieldTypeConfig?.min}
          max={props?.fieldTypeConfig?.max}
        />
      );
    }
    case "InputField_Ported": {
      const {
        labelComponent,
        fieldLockedObject,
        customRef,
        mode,
        isRequired,
        onBlurInputField,
        onFocusInputField,
        label,
        subText,
        value,
        placeholder,
        updateInputField,
        readOnly,
        fieldKey,
        emptyText,
        error,
        labelStyle,
        labelContainerStyle,
        customTextStyle,
        isRtlAlignmentRequired,
        isSinglePageAndNewUnitView,
        enhancedEmptyTextFormat,
      } = props;

      return (
        <FieldInput
          isRequired={isRequired}
          error={error}
          onBlurInputField={onBlurInputField}
          onFocusInputField={onFocusInputField}
          label={label}
          subText={subText}
          value={value}
          placeholder={placeholder}
          name={fieldKey}
          updateInputField={updateInputField}
          readOnly={readOnly}
          emptyText={emptyText}
          labelComponent={labelComponent}
          customRef={customRef}
          mode={mode}
          fieldLockedObject={fieldLockedObject}
          labelStyle={labelStyle}
          labelContainerStyle={labelContainerStyle}
          onFocusOut={props.onFocusOut}
          customTextStyle={customTextStyle}
          isRtlAlignmentRequired={isRtlAlignmentRequired}
          isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
        />
      );
    }
    case "InputNumberField":
      return (
        <UIInputNumberField
          {...props}
          label={props.label}
          subText={props.subText}
          type={"number"}
          value={props.value}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          numberLabel={props.subLabel}
        />
      );
    case "StepperInputField": {
      const {
        disabled,
        value,
        fieldKey,
        min,
        max,
        step,
        label,
        testId,
        regexString,
        placeholder,
      } = props;
      return (
        <StepperInputField
          {...props}
          value={value}
          placeholder={placeholder}
          name={fieldKey}
          updateInputField={props.updateInputField}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          label={label}
          testId={testId}
          regexString={regexString}
        />
      );
    }

    case "InputNumberFieldV2": {
      return (
        <InputNumberFieldV2
          {...props}
          isRequired={props.isRequired}
          onBlurInputField={props.onBlurInputField}
          onFocusInputField={props.onFocusInputField}
          label={props.label}
          subText={props.subText}
          value={props.value}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          disabled={props.lockFieldForSchoolGroups || props.disabled}
          size={isDSV2 ? "medium" : "large"}
        />
      );
    }
    case "Duration":
      return (
        <Duration
          {...props}
          label={props.label}
          subText={props.subText}
          type={"number"}
          value={props.value}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          numberLabel={props.subLabel}
        />
      );
    case "TextArea": {
      const { useControlledInput = false } = props;
      return useControlledInput ? (
        <ControlledInputWrapper
          value={props.value}
          updateInputField={props.updateInputField}
          name={props.fieldKey}
          shouldSyncLocalStateWithInput={props.shouldSyncLocalStateWithInput}
        >
          <FormTextAreaInput
            {...props}
            onBlurInputField={props.onBlurInputField}
            onFocusInputField={props.onFocusInputField}
            label={props.label}
            subText={props.subText}
            value={props.value}
            placeholder={props.placeholder}
            name={props.fieldKey}
            updateInputField={props.updateInputField}
            disabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          />
        </ControlledInputWrapper>
      ) : (
        <FormTextAreaInput
          {...props}
          onBlurInputField={props.onBlurInputField}
          onFocusInputField={props.onFocusInputField}
          label={props.label}
          subText={props.subText}
          value={props.value}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          disabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
        />
      );
    }
    case "ImageDropzone":
      return (
        <ImageDropzoneV2
          {...props}
          onBlurInputField={props.onBlurInputField}
          onFocusInputField={props.onFocusInputField}
          label={props.label}
          subText={props.subText}
          value={props.value}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          parentId={props.parentId}
          fieldParentType={props.parentType}
          parentType={"IMAGE_DROPZONE"}
          isDisabled={props.lockFieldForSchoolGroups}
          isAssessmentCreationRevamp={props.isAssessmentCreationRevamp}
          {...props.fieldTypeConfig}
        />
      );
    case "SegmentControl":
      return (
        <UISegmentedControl
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          isDisabled={props.isDisabled}
          options={props.options}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          containerStyle={{
            ..._.get(props, "fieldTypeConfig.containerStyle", {}),
            ...segmentedControlStyle.containerStyle,
          }}
        />
      );
    case "IBTheme":
    case "MultiSelectWithIcon":
      return (
        <ThemeSelectComponent
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          isDisabled={props?.disabled ? true : props.isDisabled}
          options={props.options}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
        />
      );
    case "GenericCardList":
      return (
        <GenericCardList
          {...props}
          allowMultiSelect={props?.fieldTypeConfig?.allowMultiSelect}
          isUpdateActionsAllowed={
            props?.fieldTypeConfig?.isUpdateActionsAllowed
          }
          disabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          showSubtextUnderInfo={
            props?.fieldTypeConfig?.showSubtextUnderInfo || false
          }
        />
      );
    case "GenericCardList_Ported": {
      const {
        value,
        options,
        labelComponent,
        fieldKey,
        updateInputField,
        isUpdateActionsAllowed,
        totalColumns,
        showReflection,
        emptyText,
        enhancedEmptyTextFormat,
        customRef,
        disabled,
        lockFieldForSchoolGroups,
        label,
        mode,
        showSubtextUnderInfo,
        allowMultiSelect,
        resetOptions,
        containerStyle,
      } = props;

      return (
        <GenericCardList
          customRef={customRef}
          disabled={disabled ? true : lockFieldForSchoolGroups}
          label={label}
          mode={mode}
          labelComponent={labelComponent}
          value={value}
          options={options}
          name={fieldKey}
          updateInputField={updateInputField}
          isUpdateActionsAllowed={isUpdateActionsAllowed}
          totalColumns={totalColumns}
          showReflection={showReflection}
          emptyText={emptyText}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
          showSubtextUnderInfo={showSubtextUnderInfo}
          allowMultiSelect={allowMultiSelect}
          resetOptions={resetOptions}
          containerStyle={containerStyle}
        />
      );
    }
    case "GenericCheckList":
      return (
        <GenericCheckList
          {...props}
          showSubtextUnderInfo={
            props?.fieldTypeConfig?.showSubtextUnderInfo || false
          }
          tooltipPlacement={props?.fieldTypeConfig?.tooltipPlacement}
          fixArrowPosition={props?.fieldTypeConfig?.fixArrowPosition}
          disabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          subFieldValue={props.subFieldValue}
          subField={props.subField}
          isDependentField={props?.fieldTypeConfig?.isDependentField}
        />
      );
    case "GenericCheckList_Ported": {
      const {
        value,
        options,
        labelComponent,
        name,
        updateInputField,
        disabled,
        lockFieldForSchoolGroups,
        showSubtextUnderInfo,
        tooltipPlacement,
        fixArrowPosition,
        subFieldValue,
        subField,
        isDependentField,
        showTextBoxOnSelect,
        isGroupedOptions,
        shouldFilterParentNodesOnUpdate,
        isMultiColumn,
        emptyText,
        enhancedEmptyTextFormat,
        emptyEditText,
        mode,
        containerStyle,
      } = props;

      return (
        <GenericCheckList
          labelComponent={labelComponent}
          value={value}
          options={options}
          name={name}
          updateInputField={updateInputField}
          disabled={disabled ? true : lockFieldForSchoolGroups}
          showSubtextUnderInfo={showSubtextUnderInfo}
          tooltipPlacement={tooltipPlacement}
          fixArrowPosition={fixArrowPosition}
          subFieldValue={subFieldValue}
          subField={subField}
          isDependentField={isDependentField}
          showTextBoxOnSelect={showTextBoxOnSelect}
          isGroupedOptions={isGroupedOptions}
          shouldFilterParentNodesOnUpdate={shouldFilterParentNodesOnUpdate}
          isMultiColumn={isMultiColumn}
          emptyText={emptyText}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
          mode={mode}
          emptyEditText={emptyEditText}
          containerStyle={containerStyle}
        />
      );
    }
    case "MultiSelectWithImage":
      return (
        <MultiSelectWithImage
          {...props}
          isRequired={props.isRequired}
          error={props?.fieldTypeConfig?.error}
          label={props.label}
          subText={props.subText}
          multi={props.multi}
          value={props.value}
          options={props.options}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
        />
      );
    case "MultiSelectWithModal":
      return (
        <MultiSelectWithModal
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          options={props.options}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
        />
      );
    case "IBConcepts":
      return (
        <KeyConcepts
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          options={props.options}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          testId="unitPlans-keyConcepts"
        />
      );
    case "IBMultiSelectQuestion":
      return (
        <MultiSelectQuestions
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          mode={props.mode}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
          options={props.options}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
        />
      );
    case "IBRelatedConcepts":
      return (
        <RelatedConcepts
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          mode={props.mode}
          name={props.fieldKey}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
          options={props.options}
          updateInputField={props.updateInputField}
        />
      );
    case "IBRelatedConceptsV2":
      return (
        <RelatedConceptsV2
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          mode={props.mode}
          name={props.fieldKey}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
          options={props.options}
          updateInputField={props.updateInputField}
          isCourseOverview={props.isCourseOverview}
        />
      );
    case "IBRelatedConceptsV2_Ported": {
      const {
        customRef,
        options,
        fieldKey,
        label,
        labelComponent,
        mode,
        updateInputField,
        value,
        resolvedValue,
        fieldLockedObject,
        readOnly,
        onFocusInputField,
        onBlurInputField,
      } = props;
      return (
        <RelatedConceptsV2
          customRef={customRef}
          options={options}
          fieldKey={fieldKey}
          label={label}
          labelComponent={labelComponent}
          mode={mode}
          hasAddRemoveValues={true}
          updateInputField={updateInputField}
          value={value}
          resolvedValue={resolvedValue}
          fieldLockedObject={fieldLockedObject}
          readOnly={readOnly}
          onFocusInputField={onFocusInputField}
          onBlurInputField={onBlurInputField}
        />
      );
    }
    case "IBMultiSelect":
    case "MultiSelect": {
      return (
        <MultiSelectComponent
          {...props}
          isRequired={props.isRequired}
          error={props?.fieldTypeConfig?.error}
          label={props.label}
          subText={props.subText}
          multi={props.multi}
          value={props.value}
          emptyText={props.emptyText}
          options={props.options}
          name={props.fieldKey}
          listItemStyle={_.get(props.styles, "listItemStyle", {})}
          updateInputField={props.updateInputField}
        />
      );
    }
    case "MultiSelectV2": {
      return (
        <MultiSelectComponentV2
          {...props}
          label={props.label}
          subText={props.subText}
          multi={props.multi}
          value={props.value}
          emptyText={props.emptyText}
          options={props.options}
          name={props.fieldKey}
          listItemStyle={_.get(props.styles, "listItemStyle", {})}
          updateInputField={props.updateInputField}
        />
      );
    }
    case "RichText": {
      const {
        renderNewEditor = true,
        pluginsConfig = {},
        showLexicalRTE = true,
        height = 170,
      } = props;

      const updatedPluginConfig = {
        ...pluginsConfig,
        ai: {
          isEnabled: props.isAIEnabledInRTE,
        },
      };

      return (
        <RichTextEditor
          {...props}
          label={props.label}
          subText={props.subText}
          onBlurInputField={props.onBlurInputField}
          onFocusInputField={props.onFocusInputField}
          value={props.value}
          width={"100%"}
          height={height}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          renderNewEditor={renderNewEditor}
          pluginsConfig={updatedPluginConfig}
          showLexicalRTE={showLexicalRTE}
          fontSize={props.isSinglePageAndNewUnitView ? "small" : "medium"}
          showDragHandles={props.showDragHandles}
        />
      );
    }

    case "RichText_Ported": {
      const {
        labelComponent,
        mode,
        updateInputField,
        onFocusInputField,
        onBlurInputField,
        value,
        customRef,
        fieldLockedObject,
        fieldKey,
        emptyText,
        textStyle,
        applyDefaultClass,
        customTextStyle,
        label,
        lockFieldForSchoolGroups,
        readOnly,
        isRequired,
        subText,
        labelStyle,
        labelContainerStyle,
        isMediaRestricted,
        renderNewEditor = true,
        customValidation,
        isAIEnabledInRTE,
        enableEditorObserver,
        shouldCallOnBlur,
        hideErrorMessage,
        isRtlAlignmentRequired,
        sanitizationType,
        isActive,
        toolbarPosition,
        isHeightAdaptive,
        pluginsConfig,
        isSinglePageAndNewUnitView,
        isToolbarSticky,
        height,
        enhancedEmptyTextFormat,
        showMediaLinkInTheatreMode,
        shouldInheritFontSize,
        dsVersion,
        extendedToolbarButtons,
        showDocEditor,
        allowCopyPasteInEquationEditor = true,
        disabledCopyButtonTooltipText = null,
        isLinkDisabled,
      } = props;

      return (
        <FieldRichText
          labelComponent={labelComponent}
          mode={mode}
          updateInputField={updateInputField}
          onFocusInputField={onFocusInputField}
          onBlurInputField={onBlurInputField}
          onFocusOut={props.onFocusOut}
          value={value}
          name={fieldKey}
          subText={subText}
          customRef={customRef}
          fieldLockedObject={fieldLockedObject}
          fieldKey={fieldKey}
          emptyText={emptyText}
          textStyle={textStyle}
          applyDefaultClass={applyDefaultClass}
          customTextStyle={customTextStyle}
          label={label}
          lockFieldForSchoolGroups={lockFieldForSchoolGroups}
          isRequired={isRequired}
          readOnly={readOnly}
          labelStyle={labelStyle}
          labelContainerStyle={labelContainerStyle}
          isMediaRestricted={isMediaRestricted}
          renderNewEditor={renderNewEditor}
          customValidation={customValidation}
          isAIEnabledInRTE={isAIEnabledInRTE}
          enableEditorObserver={enableEditorObserver}
          shouldCallOnBlur={shouldCallOnBlur}
          hideErrorMessage={hideErrorMessage}
          isRtlAlignmentRequired={isRtlAlignmentRequired}
          sanitizationType={sanitizationType}
          isActive={isActive}
          toolbarPosition={toolbarPosition}
          isHeightAdaptive={isHeightAdaptive}
          pluginsConfig={pluginsConfig}
          isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          isToolbarSticky={isToolbarSticky}
          height={height}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
          showMediaLinkInTheatreMode={showMediaLinkInTheatreMode}
          showDragHandles={props.showDragHandles}
          shouldInheritFontSize={shouldInheritFontSize}
          dsVersion={dsVersion}
          extendedToolbarButtons={extendedToolbarButtons}
          showDocEditor={showDocEditor}
          allowCopyPasteInEquationEditor={allowCopyPasteInEquationEditor}
          disabledCopyButtonTooltipText={disabledCopyButtonTooltipText}
          isLinkDisabled={isLinkDisabled}
        />
      );
    }

    case "TextArea_Ported": {
      const {
        placeholder,
        onBlurInputField,
        onFocusInputField,
        label,
        subText,
        value,
        fieldKey,
        updateInputField,
        labelComponent,
        mode,
        fieldLockedObject,
        customRef,
        readOnly,
        isRequired,
        textStyle,
        applyDefaultClass,
        customTextStyle,
        emptyText,
        labelStyle,
        labelContainerStyle,
        isRtlAlignmentRequired,
        isSinglePageAndNewUnitView,
        enhancedEmptyTextFormat,
      } = props;

      return (
        <FieldMultiLineInput
          name={fieldKey}
          value={value}
          fieldKey={fieldKey}
          mode={mode}
          label={label}
          subText={subText}
          placeholder={placeholder}
          labelComponent={labelComponent}
          updateInputField={updateInputField}
          onBlurInputField={onBlurInputField}
          onFocusInputField={onFocusInputField}
          fieldLockedObject={fieldLockedObject}
          customRef={customRef}
          readOnly={readOnly}
          isRequired={isRequired}
          textStyle={textStyle}
          applyDefaultClass={applyDefaultClass}
          customTextStyle={customTextStyle}
          emptyText={emptyText}
          labelStyle={labelStyle}
          labelContainerStyle={labelContainerStyle}
          onFocusOut={props.onFocusOut}
          isRtlAlignmentRequired={isRtlAlignmentRequired}
          isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
        />
      );
    }
    case "IBReflection_Ported": {
      const {
        label,
        subText,
        labelComponent,
        mode,
        responses,
        labelStyle,
        labelContainerStyle,
        styles = {},
        emptyText,
        customRef,
        textStyle,
        isRequired,
        t,
        prompts,
        readOnly,
        fieldLockedObject,
        isSinglePageAndNewUnitView,
        shouldShowPromptsForStudent,
      } = props;
      return (
        <FieldReflection
          label={label}
          subText={subText}
          labelComponent={labelComponent}
          mode={mode}
          responses={responses}
          labelStyle={labelStyle}
          labelContainerStyle={labelContainerStyle}
          subTextStyle={styles.subTextStyle}
          emptyText={emptyText}
          customRef={customRef}
          textStyle={textStyle}
          isRequired={isRequired}
          t={t}
          prompts={prompts}
          readOnly={readOnly}
          fieldLockedObject={fieldLockedObject}
          isSinglePageAndNewUnitView={isSinglePageAndNewUnitView}
          shouldShowPromptsForStudent={shouldShowPromptsForStudent}
        />
      );
    }
    case "IBAssessLearning":
      return (
        <AssessStudentLearning
          {...props}
          label={props.label}
          subText={props.subText}
          options={props.options}
          value={props.value}
          width={"100%"}
          height={170}
          placeholder={props.placeholder}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
        />
      );

    case "CollaboratorV2": {
      const updateFields = value => {
        props.updateInputField(value, {
          isMappedWithDetailsFields: props.isMappedWithDetailsFields,
        });
      };

      return (
        <CollaboratorV2
          {...props}
          value={props.value || []}
          updateInputField={updateFields}
          {...props.fieldTypeConfig}
          {...props.styles}
        />
      );
    }
    case "IBBenchmarks":
      return (
        <BenchmarksComponent
          {...props}
          label={props.label}
          subText={props.subText}
          options={props.options}
          value={props.value}
          resolvedValue={props.resolvedValue}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          readOnly={props.readOnly}
          testId="unitPlans-benchmarksComponent"
        />
      );
    case "IBAssessments":
      return (
        <AssessmentLibrary
          {...props}
          label={props.label}
          subText={props.subText}
          options={props.options}
          name={props.fieldKey}
          mode={props.mode}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
        />
      );
    case "IBLearningEngagements":
      return (
        <LeLibrary
          {...props}
          label={props.label}
          subText={props.subText}
          options={props.options}
          name={props.fieldKey}
          mode={props.mode}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
          maxItemCount={props.maxItemCount || 2}
        />
      );
    case "IBSkills":
      return (
        <IBSkills
          {...props}
          label={props.label}
          subText={props.subText}
          options={props.options}
          value={props.value}
          name={props.fieldKey}
          updateInputField={props.updateInputField}
          testId="unitPlans-IBSkills"
        />
      );

    case "NestedSelectComponent":
      return (
        <NestedSelectComponent
          {...props}
          showEditButtonAtHeader={
            props.lockFieldForSchoolGroups ? true : props.showEditButtonAtHeader
          }
        />
      );

    case "MultiField":
      return (
        <MultiField
          {...props}
          value={props.value || {}}
          containerStyle={{ gridGap: 16 }}
        />
      );

    case "MultiFieldV2": {
      return <MultiFieldV2 {...props} value={props.value || {}} />;
    }

    case "DynamicChildren":
      return <DynamicChildren {...props} />;
    case "SelectAttachmentComponent":
      return <SelectAttachmentComponent {...props} />;

    case "SwitcherComponent":
      return (
        <SwitcherComponent
          {...props}
          labelContainerStyle={{
            ...styles.switcherComponentLabelStyle,
            ...props.labelContainerStyle,
          }}
        />
      );
    case "AlertWithCheckbox":
      return <AlertWithCheckbox {...props} />;

    case "RadioButtonList":
      return (
        <RadioButtonList
          {...props}
          label={props.label}
          subText={props.subText}
          value={props.value}
          options={props.options}
          name={props.fieldKey}
          listContainerStyle={_.get(props.styles, "listContainerStyle", {})}
          listItemStyle={_.get(props.styles, "listItemStyle", {})}
          isOptionWithBorder={_.get(
            props,
            "fieldTypeConfig.isOptionWithBorder",
            false
          )}
          updateInputField={props.updateInputField}
          useCardSelection={_.get(props.styles, "useCardSelection", false)}
        />
      );
    case "CheckList": {
      let checkListValue = props.value ? props.value : [];
      /* Added this case to specifically handle The case of DP pedgogical approaches where we need
       the backend structure of input list and view mode of checklist */
      if (props.isInputListType) {
        checkListValue = _.map(
          _.filter(props.value, { isSelected: true }),
          val => val.id
        );
      }
      const updateFields = value => {
        if (props.isInputListType)
          props.updateInputField({
            [props.fieldKey]: _.map(props.options, option => {
              return {
                id: option.id,
                value: option.label,
                isSelected: _.includes(value[props.fieldKey], option.id),
              };
            }),
          });
        else if (props.configType == "PLANNER_ELEMENT")
          props.updateInputField(value, {
            nodes: props.options,
          });
        else
          props.updateInputField(value, {
            isMappedWithDetailsFields: props.isMappedWithDetailsFields,
          });
      };

      const { styles = {} } = props;

      const {
        listItemStyle = {},
        informationIconSize = "xxx-small",
        checkBoxLabelStyles = {},
        listContainerStyle = {},
        checkListContainerStyle = {},
        checkboxStyles = {},
      } = styles;
      return (
        <CheckListContainer
          {...props}
          mode={props.mode}
          label={props.label}
          subText={props.subText}
          emptyText={props.emptyText}
          value={checkListValue}
          options={props.options}
          name={props.fieldKey}
          checkListContainerStyle={{
            ...listContainerStyle,
            ...checkListContainerStyle,
          }}
          labelStyle={props.labelStyle}
          labelContainerStyle={props.labelContainerStyle}
          updateInputField={updateFields}
          listItemStyle={listItemStyle}
          testId={props.testId}
          informationIconSize={informationIconSize}
          CheckBoxLabelStyles={checkBoxLabelStyles}
          checkboxStyles={checkboxStyles}
        />
      );
    }
    case "CheckListWithDuration": {
      const {
        value,
        showComment,
        options,
        updateInputField,
        fieldKey,
        disabled,
        displayDisabledAsActive,
        labelComponent,
        label,
        getFieldValue,
        styles,
        maxLength,
        regexString,
        durationFieldUid,
        stepperValue,
        isFloatValue,
        maxNumLength,
        tooltipPosition,
        listItemStyle = {},
        fallbackValue,
        shouldUpdateValueOnMount,
        containerStyle,
        testId,
      } = props;

      return (
        <CheckListWithDuration
          value={value}
          label={label}
          showComment={showComment}
          options={options}
          updateInputField={updateInputField}
          fieldKey={fieldKey}
          disabled={disabled}
          labelComponent={labelComponent}
          displayDisabledAsActive={displayDisabledAsActive}
          getFieldValue={getFieldValue}
          styles={styles}
          maxLength={maxLength}
          regexString={regexString}
          durationFieldUid={durationFieldUid}
          stepperValue={stepperValue}
          isFloatValue={isFloatValue}
          maxNumLength={maxNumLength}
          tooltipPosition={tooltipPosition}
          listItemStyle={listItemStyle}
          fallbackValue={fallbackValue}
          shouldUpdateValueOnMount={shouldUpdateValueOnMount}
          containerStyle={containerStyle}
          testId={testId}
        />
      );
    }
    case "BenchmarkCheckList":
      return (
        <BenchmarkCheckList
          {...props}
          name={props.fieldKey}
          options={props.options}
          resolvedValue={props.resolvedValue}
        />
      );
    case "NestedCheckList":
      return <NestedChecklist {...props} />;
    case "SelectDropdown":
      return <SelectDropdownDynamicOptions size="large" {...props} />;
    case "MeasureAssessing": {
      return props.isAssessmentCreationRevamp ? (
        <MeasureAssessingWrapper {...props} />
      ) : (
        <SelectDropdownDynamicOptions {...props} options={props.options} />
      );
    }

    case "Exemplar":
    case "Rubrics":
    case "Anecdotal":
    case "AssessmentSinglePointRubric":
    case "AssessmentChecklist":
    case "AssessmentTool": {
      return (
        !props?.isAssessmentCreationRevamp && (
          <AssessmentTool
            {...props}
            label={props.label}
            showViewEmpty={false}
            subText={props.subText}
            mode={props.mode}
            type={props.toolType}
            labelStyle={props.labelStyle}
            labelContainerStyle={props.labelContainerStyle}
            parentType={props.parentType}
            parentId={props.parentId}
            value={props.value ? props.value : ""}
            fieldId={props.fieldId ? props.fieldId : ""}
            options={props.options ? props.options : {}}
            name={props.fieldKey ? props.fieldKey : ""}
            updateInputField={
              props.updateInputField ? props.updateInputField : ""
            }
            assessmentToolId={props.assessmentToolId}
            assessmentToolsConStyle={props.assessmentToolsConStyle}
            showAttachmentItemV3={props.showAttachmentItemV3}
            horizontalAssessmentToolCardStyle={
              props.horizontalAssessmentToolCardStyle
            }
          />
        )
      );
    }
    case "ListView":
      return (
        <Listview
          {...props}
          mode={props.mode}
          label={props.label}
          subText={props.subText}
          value={props.value ? props.value : []}
          name={props.fieldKey}
          labelStyle={props.labelStyle}
          customTextStyle={props.contentStyle}
          labelContainerStyle={props.labelContainerStyle}
        />
      );

    case "InputNumberListWithTag": {
      return (
        <InputNumberListWithTag
          {...props}
          mode={props.mode}
          label={props.label}
          subText={props.subText}
          value={props.value ?? []}
          name={props.fieldKey}
        />
      );
    }

    case "TextView":
      return (
        <Textview
          {...props}
          mode={props.mode}
          label={props.label}
          subText={props.subText}
          value={props.value ? props.value : ""}
          name={props.fieldKey}
          labelStyle={props.labelStyle}
          customTextStyle={props.textViewcustomTextStyle}
          labelContainerStyle={props.labelContainerStyle}
          applyDefaultClass={!props.isApplyCustomTextStyle}
        />
      );
    case "ScopeAndSequence":
    case "Nestedview":
      return (
        <BenchmarkView
          {...props}
          mode={props.mode}
          label={props.label}
          subText={props.subText}
          value={props.value ? props.value : []}
          name={props.fieldKey}
          isDsComponent={props?.isDsComponent}
        />
      );

    case "AudioRecorder":
      return (
        <AudioRecorderSelector
          {...props}
          mode={props.mode}
          label={props.label}
          subText={props.subText}
          value={props.value ? props.value : {}}
          name={props.fieldKey}
          labelStyle={props.labelStyle}
          labelContainerStyle={{
            marginBottom: 16,
            ...props.labelContainerStyle,
          }}
          parentId={props.parentId}
          parentType={props.parentType}
          version={"v4"}
          showWaveform={props.showWaveform}
          {...audioRecorderSelectorStyles}
        />
      );

    case "ResourceList":
      return (
        <OrganizationResourcesSelection
          {...props}
          mode={props.mode}
          label={props.label}
          subText={props.subText}
          cardType={
            props.showAttachmentItemV3 ? "horizontalV3" : props.cardType
          }
          showAttachmentItemV3={props.showAttachmentItemV3}
          horizontalCardStyle={props.resourceContainerStyle}
          testId={props.testId}
        />
      );
    case "GroupedConceptsView":
      return <GroupedKeyConceptsView {...props} />;
    case "SubjectGroupSelect":
      return <SubjectGroupSelect {...props} />;
    case "SubjectGroupSelectV2":
      return <SubjectGroupSelectV2 {...props} />;
    case "SubjectGroupSubjectView":
      return <SubjectGroupWithSubjectView {...props} />;
    case "SubjectGroupSubjectViewOnly":
      return <SubjectGroupWithSubjectViewOnly {...props} />;
    case "SubjectViewOnly":
      return <SubjectViewOnly {...props} />;
    case "StudentResponse":
      return <StudentResponse {...props} />;
    case "ToggleSwitch":
      return <ToggleSwitchInput {...props} isDisabled={props?.disabled} />;
    case "ListModal":
      return (
        <ListModal
          {...props}
          value={props.value}
          options={props.options}
          label={props.label}
          editLabel={props.editLabel}
          modalTitleLabel={props.modalTitleLabel}
          modalSearchPlaceholder={props.modalSearchPlaceholder}
          updateInputField={props.updateInputField}
          fieldTypeConfig={props.fieldTypeConfig}
          isBoxDisabled={props?.disabled}
        />
      );

    case "TOKObject":
      return (
        <TOKObject
          {...props}
          value={props.value}
          label={props.label}
          editLabel={props.editLabel}
          modalTitleLabel={props.modalTitleLabel}
          modalTitleEditLabel={props.modalTitleEditLabel}
          updateInputField={props.updateInputField}
        />
      );

    case "CriteriaRubricAssessment":
      return (
        <CriteriaRubricAssessmentWithComments
          {...props}
          onSelectMark={props.onSelectRubricAssessmentCriteriaRating}
          isRatingEditable={props.isRatingEditable && !props.disabled}
        />
      );

    case "SubmissionItem":
      return (
        <SubmissionItem
          {...props}
          labelContainerStyle={{
            ...styles.submissionItemLabelStyle,
            ...(isDSV2 ? styles.submissionItemLabelStyleV2 : {}),
            ...props.labelContainerStyle,
          }}
        />
      );

    case "SubmissionTable":
      return <SubmissionTable {...props} />;

    case "LineSeparator":
      return <LineSeparator {...props} />;

    case "DynamicTable":
      return <DynamicTable {...props} />;
    case "EmptyComponent":
      return <EmptyComponent {...props} />;

    case "AssessmentCategory":
      return (
        <AssessmentCategory
          {...props}
          updateInputField={props.updateInputField}
          dependentFieldValue={props.dependentFieldValue}
        />
      );

    case "MaxScore": {
      return <MaxScore {...props} updateInputField={props.updateInputField} />;
    }

    case "TaskWeight":
      return <TaskWeightV2 {...props} />;
    case "TaskWeightV3":
      return <TaskWeightV3 {...props} />;

    case "DurationAndPrescribedPractical":
      return (
        <DurationAndPrescribedPractical
          {...props}
          updateInputField={props.updateInputField}
        />
      );
    case "DurationAndTopic":
      return (
        <DurationAndTopic
          {...props}
          updateInputField={props.updateInputField}
        />
      );

    case "FinalRemark":
      return <FinalRemark {...props} />;

    case "LearningGoalsRating":
      return <LearningGoalsRating {...props} />;
    case "AddLearningGoals":
      return <AddLearningGoals {...props} />;
    case "TreeView":
      return <TreeView {...props} />;
    case "PlannerElementDataSet":
      return <PlannerElementDataSet {...props} />;
    case "PlannerElementDataSet_Ported": {
      const {
        label,
        labelComponent,
        mode,
        updateInputField,
        value,
        name,
        customRef,
        plannerElementSet,
        resolvedValue,
        allowedColumns,
        containerStyle,
        options,
        learningCourseId,
        unitPlanId,
        shouldOpenModalOnMount,
        onBlurInputField,
        parentNodeId,
        onClose,
      } = props;
      return (
        <PlannerElementDataSet
          label={label}
          labelComponent={labelComponent}
          mode={mode}
          updateInputField={updateInputField}
          value={value}
          name={name}
          customRef={customRef}
          plannerElementNodes={_.get(plannerElementSet, "nodes", [])}
          resolvedValue={resolvedValue}
          allowedColumns={allowedColumns}
          isSinglePageAndNewUnitView={true}
          containerStyle={containerStyle}
          options={options}
          learningCourseId={learningCourseId}
          unitPlanId={unitPlanId}
          shouldOpenModalOnMount={shouldOpenModalOnMount}
          onBlurInputField={onBlurInputField}
          parentNodeId={parentNodeId}
          isPortedField={true}
          onClose={onClose}
        />
      );
    }
    case "CardView":
      return <CardView {...props} />;
    case "LearningGoalsNestedView":
      return <LearningGoalsNestedView {...props} />;
    case "LearningGoalsListView":
      return <LearningGoalsListView {...props} />;
    case "FieldDropdown":
      return <FieldDropdown {...props} />;
    case "CARD_Ported": {
      const {
        mode,
        labelComponent,
        plannerElementSet,
        plannerElementNodeSet,
        name,
        value,
        label,
        fieldObj,
        t,
        updateInputField,
        fieldKey,
        customRef,
        customTextStyle = {},
        isSinglePageAndNewUnitView = false,
        fieldTypeConfig = {},
        emptyText,
        enhancedEmptyTextFormat,
        disabled,
        lockFieldForSchoolGroups,
      } = props;

      const {
        containerStyle,
        allowMultiSelect,
        updateSingleSelectValueAsList,
      } = fieldTypeConfig;

      return isSinglePageAndNewUnitView ? (
        <GenericCardList
          customRef={customRef}
          disabled={disabled ? true : lockFieldForSchoolGroups}
          label={label}
          labelComponent={labelComponent}
          mode={mode}
          updateInputField={updateInputField}
          options={_.map(
            _.get(
              plannerElementNodeSet,
              "plannerElementNodeSetWrapperV2.publishedData.edges",
              []
            ),
            "node"
          )}
          value={value}
          name={name}
          fieldKey={fieldKey}
          isSinglePageAndNewUnitView={true}
          containerStyle={containerStyle}
          allowMultiSelect={allowMultiSelect}
          updateSingleSelectValueAsList={updateSingleSelectValueAsList}
          emptyText={emptyText}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
        />
      ) : (
        <FieldCardsV2
          customRef={customRef}
          label={label}
          labelComponent={labelComponent}
          mode={mode}
          updateInputField={updateInputField}
          plannerElementSet={plannerElementSet}
          value={value}
          name={name}
          fieldObj={fieldObj}
          emptyText={getFieldEmptyText({ plannerElementSet, mode, t })}
          fieldKey={fieldKey}
          customTextStyle={customTextStyle}
        />
      );
    }
    case "CHECKLIST_Ported": {
      const {
        mode,
        labelComponent,
        plannerElementSet,
        plannerElementNodeSet,
        name,
        value,
        label,
        fieldObj,
        t,
        updateInputField,
        customTextStyle = {},
        isSinglePageAndNewUnitView = false,
        fieldTypeConfig = {},
        emptyText,
        enhancedEmptyTextFormat,
        lockFieldForSchoolGroups,
        disabled,
      } = props;

      const { containerStyle = {} } = fieldTypeConfig;

      return isSinglePageAndNewUnitView ? (
        <GenericCheckList
          label={label}
          labelComponent={labelComponent}
          disabled={disabled ? true : lockFieldForSchoolGroups}
          mode={mode}
          updateInputField={updateInputField}
          value={value}
          name={name}
          options={_.map(
            _.get(
              plannerElementNodeSet,
              "plannerElementNodeSetWrapperV2.publishedData.edges",
              []
            ),
            "node"
          )}
          isSinglePageAndNewUnitView={true}
          containerStyle={containerStyle}
          emptyText={emptyText}
          enhancedEmptyTextFormat={enhancedEmptyTextFormat}
        />
      ) : (
        <FieldChecklist
          label={label}
          labelComponent={labelComponent}
          mode={mode}
          updateInputField={updateInputField}
          plannerElementSet={plannerElementSet}
          value={value}
          name={name}
          fieldObj={fieldObj}
          emptyText={getFieldEmptyText({ plannerElementSet, mode, t })}
          customTextStyle={customTextStyle}
        />
      );
    }
    case "NESTED_CHECKLIST_Ported": {
      const {
        mode,
        labelComponent,
        plannerElementSet,
        name,
        value,
        label,
        fieldObj,
        t,
        updateInputField,
        customRef,
        options,
        nodeLabelStyle = [],
        isSinglePageAndNewUnitView = false,
        fieldTypeConfig = {},
        shouldOpenModalOnMount,
        onBlurInputField,
      } = props;

      const { allowedColumns = [], containerStyle = {} } = fieldTypeConfig;
      const { resolvedMinimalTree: resolvedValue = {} } = options;
      return isSinglePageAndNewUnitView ? (
        <PlannerElementDataSet
          label={label}
          labelComponent={labelComponent}
          mode={mode}
          updateInputField={updateInputField}
          value={value}
          name={name}
          customRef={customRef}
          resolvedValue={resolvedValue}
          plannerElementNodes={_.get(plannerElementSet, "nodes", [])}
          allowedColumns={allowedColumns}
          isPortedField={true}
          isSinglePageAndNewUnitView={true}
          containerStyle={containerStyle}
          options={options}
          shouldOpenModalOnMount={shouldOpenModalOnMount}
          onBlurInputField={onBlurInputField}
        />
      ) : (
        <FieldNestedChecklist
          label={label}
          labelComponent={labelComponent}
          mode={mode}
          updateInputField={updateInputField}
          plannerElementSet={plannerElementSet}
          value={value}
          name={name}
          fieldObj={fieldObj}
          emptyText={getFieldEmptyText({ plannerElementSet, mode, t })}
          customRef={customRef}
          options={options}
          nodeLabelStyle={nodeLabelStyle}
          onBlurInputField={onBlurInputField}
        />
      );
    }
    case "LearningIntentions":
      return (
        <LearningIntentions
          {...props}
          value={props.value ? props.value : []}
          placeholder={props.placeholder}
          name={props.fieldKey}
          isDisabled={props?.disabled ? true : props?.lockFieldForSchoolGroups}
          emptyText=""
        />
      );
    case "AssessmentCoverUpload":
      return (
        <AssessmentCoverUpload
          {...props}
          name={props.fieldKey}
          fieldParentType={props.fieldParentType || props.parentType}
          parentType={"IMAGE_DROPZONE"}
          isDisabled={props.lockFieldForSchoolGroups}
          testId={props.testId}
        />
      );
    case "ImageCoverUpload":
      return (
        <ImageCoverUpload
          {...props}
          name={props.fieldKey}
          isDisabled={props.lockFieldForSchoolGroups}
          testId={props.testId}
        />
      );
    case "AIAnalysisScale":
      return <AIAnalysisScale {...props} name={props.fieldKey} />;
    case "WorksheetCreateType":
      return <WorksheetCreateType {...props} />;
    case "FieldAIEvaluation":
      return (
        <FieldAIEvaluation
          {...props}
          updateInputField={props.updateInputField}
        />
      );
    case "SupervisorFeedback": {
      return <FeedbackTable {...props} />;
    }
    case "FieldAIEvaluationLanguage":
      return (
        <FieldAIEvaluationLanguage
          {...props}
          updateInputField={props.updateInputField}
        />
      );
    default:
      return null;
  }
};
class FieldComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.fieldRef = null;
    this.reflectionRef = null;
    this.timer = null;
    this.otherField = {};
  }

  startTimer = () => {
    const { isModalField, shouldBlurOnInActive } = this.props;
    const { isReflection } = this.otherField;
    let inActiveTimeout = TEXT_FIELD_TIMEOUT;
    if (isReflection || isModalField) {
      inActiveTimeout = MODAL_FIELD_TIMEOUT;
    }

    if (shouldBlurOnInActive) {
      this.timer = setTimeout(this.onTimeout, inActiveTimeout * 60 * 1000);
    }
  };

  onTimeout = () => {
    const { isReflection } = this.otherField;

    if (isReflection) {
      if (this.reflectionRef) {
        this.reflectionRef.blur({ field: this.otherField });
      }
    } else {
      if (this.fieldRef) {
        this.fieldRef.blur({ field: this.otherField });
      }
    }
  };

  stopTimer = () => {
    clearTimeout(this.timer);
  };

  restartTimer = () => {
    if (this.timer) {
      this.stopTimer();
      this.startTimer();
    }
  };

  updateInputFieldLocally = value => {
    this.restartTimer();
  };

  updateInputField = (
    value,
    extraParams,
    isWarningReq = true,
    allowAddRemoveValues = true,
    isDebounce = true
  ) => {
    const { updateInputField, hasAddRemoveValues, fieldKey } = this.props;
    if (_.isArray(value) && !_.isNil(fieldKey)) {
      value = { [fieldKey]: value };
    }
    updateInputField?.({
      params: value,
      isMutation: true,
      isDebounce: !(hasAddRemoveValues && allowAddRemoveValues) && isDebounce,
      extraParams,
      hasAddRemoveValues: hasAddRemoveValues && allowAddRemoveValues,
      isWarningReq,
    });
    this.restartTimer();
  };

  onBlurInputField = ({ params = {}, others = {} } = {}) => {
    const {
      onBlurInputField,
      fieldKey,
      isRequired = false,
      updateInputField,
      hasAddRemoveValues,
    } = this.props;
    const value = params[fieldKey];

    if (isRequired && !!value) {
      updateInputField({
        params,
        isMutation: true,
        isDebounce: false,
        hasAddRemoveValues,
      });
    }
    if (onBlurInputField) {
      onBlurInputField({ key: fieldKey, id: _.get(others, "id", null) });
    }
    this.stopTimer();
  };

  onFocusInputField = ({ others = {} } = {}) => {
    const { fieldKey, onFocusInputField } = this.props;

    const id = _.get(others, "id", null);
    if (onFocusInputField) {
      onFocusInputField({ key: fieldKey, id });
    }
    this.otherField = {
      id,
      uid: fieldKey,
      isReflection: _.includes(id, "Reflection"),
    };
    this.startTimer();
  };

  setFieldRef = ref => {
    const { customRef, fieldKey } = this.props;
    this.fieldRef = ref;
    if (customRef) {
      customRef(fieldKey, ref);
    }
  };

  setReflectionRefs = ref => {
    const { reflectionRefs, fieldKey } = this.props;
    this.reflectionRef = ref;
    if (reflectionRefs) {
      reflectionRefs(fieldKey, ref);
    }
  };

  createAttachment = attachment => {
    const { createAttachment, fieldId } = this.props;
    createAttachment({
      attachment,
      fieldId,
    });
  };

  deleteAttachment = attachmentId => {
    const { deleteAttachment, fieldId } = this.props;
    deleteAttachment({
      fieldId,
      attachmentId,
    });
  };

  render() {
    const { props } = this;
    const {
      mode,
      defaultOptions,
      getOptions,
      fieldKey,
      fieldId,
      createResponse,
      deleteResponse,
      fieldTypeConfig,
      portalType,
      contentStyle,
      assessmentToolsConStyle,
      showAttachmentItemV3,
      resourceContainerStyle,
      studentTemplateCardStyle,
      horizontalAssessmentToolCardStyle,
      textViewcustomTextStyle,
      isApplyTextViewcustomTextStyle,
      lockFieldForSchoolGroups,
      placeholder,
      disabled,
      t,
      showSeparatorLine,
      isDsComponent,
      plannerElementSet,
      resolvedValue,
      fieldObj,
      isMediaRestricted,
      renderNewEditor,
      onBlurInputField,
      shouldCallOnBlur,
      hideErrorMessage,
      isDownloadEnabled,
      isRtlAlignmentRequired,
      dsVersion,
      sanitizationType,
      customPlaceholder = "",
    } = this.props;
    const isDSV2 = dsVersion === "2.0";
    let { styles = {} } = this.props;
    if (mode == "view") {
      styles = { ...defaultViewStyle, ...styles };
    } else {
      styles = { ...defaultEditStyle, ...styles };
    }

    const typeComponent = (
      <TypeComponent
        {..._.omit(
          props,
          !_.includes(["IBReflection", "IBReflection_Ported"], props.type)
            ? ["responses"]
            : []
        )}
        options={
          getOptions
            ? getOptions({
                fieldKey,
                defaultOptions,
              })
            : defaultOptions || []
        }
        createAttachment={this.createAttachment}
        deleteAttachment={this.deleteAttachment}
        renderNewEditor={renderNewEditor}
        name={props.fieldKey}
        lockFieldForSchoolGroups={lockFieldForSchoolGroups}
        customRef={this.setFieldRef}
        labelStyle={styles.labelStyle}
        labelContainerStyle={{
          ...styles.labelContainerStyle,
          ...props.labelContainerStyle,
        }}
        updateInputFieldLocally={this.updateInputFieldLocally}
        updateInputField={this.updateInputField}
        onBlurInputField={this.onBlurInputField}
        onFocusOut={onBlurInputField}
        onFocusInputField={this.onFocusInputField}
        portalType={portalType}
        contentStyle={contentStyle}
        textViewcustomTextStyle={textViewcustomTextStyle}
        {...(fieldTypeConfig ? fieldTypeConfig : {})}
        assessmentToolsConStyle={assessmentToolsConStyle}
        showAttachmentItemV3={showAttachmentItemV3}
        studentTemplateCardStyle={studentTemplateCardStyle}
        resourceContainerStyle={resourceContainerStyle}
        horizontalAssessmentToolCardStyle={horizontalAssessmentToolCardStyle}
        isApplyCustomTextStyle={isApplyTextViewcustomTextStyle}
        placeholder={
          disabled && !customPlaceholder
            ? t("common:not_added_yet")
            : customPlaceholder || placeholder
        }
        isDsComponent={isDsComponent}
        plannerElementSet={plannerElementSet}
        resolvedValue={resolvedValue}
        fieldObj={fieldObj}
        isMediaRestricted={isMediaRestricted}
        shouldCallOnBlur={shouldCallOnBlur}
        hideErrorMessage={hideErrorMessage}
        isDownloadEnabled={isDownloadEnabled}
        isRtlAlignmentRequired={isRtlAlignmentRequired}
        sanitizationType={sanitizationType}
      />
    );

    return (
      <React.Fragment>
        {showSeparatorLine && (
          <div
            className={classNames(classes.separator, {
              [classes.separatorV2]: isDSV2,
            })}
          />
        )}
        {typeComponent}
        {props.showReflection && (
          <ResponsesComponent
            isSinglePageAndNewUnitView={props.isSinglePageAndNewUnitView}
            mode={props.mode}
            fieldId={props.fieldId}
            parentId={props.parentId}
            coachMarkId={`COACHMARKS_REFLECTIONS_${fieldId}`}
            customRef={this.setReflectionRefs}
            {...fieldTypeConfig}
            options={JSON.stringify(defaultOptions)}
            createResponse={createResponse}
            deleteResponse={deleteResponse}
            fieldKey={props.fieldKey}
            isReflectionField={props.isReflectionField}
            name={props.fieldKey}
            unitPlanCourses={props.unitPlanCourses}
            responses={props.responses}
            fieldLockedObject={props.fieldLockedObject}
            onFocusInputField={this.onFocusInputField}
            updateInputFieldLocally={this.updateInputFieldLocally}
            onBlurInputField={this.onBlurInputField}
            onMediaClick={props.onMediaClick}
            curriculumType={props.curriculumType}
            onEditClickFromViewMode={props.onEditClick}
            showResponseEditButton={props.showResponseEditButton}
            unitPlanId={props.unitPlanId}
            filterContainerClass={props.filterContainerClass}
          />
        )}
      </React.Fragment>
    );
  }
}

FieldComponent.defaultProps = {
  mode: "edit",
  isModalField: false,
  shouldBlurOnInActive: true,
  readOnly: false,
  assessmentToolsConStyle: {},
  showSeparatorLine: false,
  isDsComponent: false,
  testId: "IBComponents-fieldComponent",
  isDownloadEnabled: true,
  isActive: false,
  showMediaLinkInTheatreMode: false,
  showDocEditor: false,
};

export default compose(
  I18nHOC({ resource: ["common", "unitPlan"] }),
  withFieldComponentHOC
)(FieldComponent);
